import React, {Component} from 'react';
import Profile from "./Profile";
import {Route} from "react-router-dom";
import AddressBook from "./AddressBook";
import CompanyProfile from "./CompanyProfile";
import Privacy from "./Privacy";
import EmailNotification from "./EmailNotification";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../Boilerplate/BreadcrumbContext";
import ContactLists from "./ContactLists/ContactLists";
import EditProfile from "./EditProfile";
import {CompanyProfileEdit} from "./CompanyProfileEdit";

class AppSettings extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Settings</title>
        </Helmet>
        <Route exact path="/settings/profile" component={Profile} />
        <Route exact path="/settings/profile/edit" component={EditProfile}/>
        <Route path="/settings/contact-lists" component={ContactLists} />
        <Route path="/settings/address-book" component={AddressBook} />
        <Route exact path="/settings/company-profile" component={CompanyProfile} />
        <Route path='/settings/company-profile/edit' component={CompanyProfileEdit} />
        <Route path="/settings/privacy" component={Privacy} />
        <Route path="/settings/email-notification" component={EmailNotification} />
      </React.Fragment>
    );
  }
}

export default withBreadcrumb(
  { title: 'Settings', path: '#' },
  AppSettings
);



// WEBPACK FOOTER //
// ./src/components/Settings/AppSettings.js